export function normalizePriority(priority: string | undefined): string {
  if (!priority) return 'MEDIUM';

  const p = priority.toUpperCase();

  if (p === 'NORMAL') return 'MEDIUM';
  if (p === 'CRITICAL') return 'URGENT';

  if (['URGENT', 'HIGH', 'MEDIUM', 'LOW'].includes(p)) {
    return p;
  }

  return 'MEDIUM';
}

export function getPriorityColor(priority: string | undefined): string {
  const colors: Record<string, string> = {
    urgent: 'bg-red-600 text-white',
    high:   'bg-orange-500 text-white',
    medium: 'bg-sky-400 text-white',
    low:    'bg-gray-400 text-white',
  };

  if (!priority) return colors.medium;
  const p = priority.toLowerCase();
  if (p === 'critical') return colors.urgent;
  if (p === 'normal')   return colors.medium;

  return colors[p] || colors.medium;
}

export function getPriorityLabel(priority: string | undefined): string {
  if (!priority) return 'Medium';
  return priority.charAt(0).toUpperCase() + priority.slice(1).toLowerCase();
}
